// getIsPermissionMatched.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const defaultArray = [];
export const PermissionMatchMode = {
  SOME: 'some',
  EVERY: 'every',
};

/*
 * Get is permission matched by remote config key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} remoteConfigKey - remote config key.
 * @param {array} extraScopes - extra scope candidate to be matched
 * @return {boolean|undefined} Return true if token scopes include required scope.
 */
export const getIsPermissionMatched = createCachedSelector(
  state => getMeData(state, 'tokenScopes'),
  (state, remoteConfigKey) => getRemoteConfigData(state, remoteConfigKey),
  (state, remoteConfigKey, extraScopes) => extraScopes,
  (state, remoteConfigKey, extraScopes, matchMode = PermissionMatchMode.SOME) =>
    matchMode,
  (
    tokenScopes = defaultArray,
    scopes = defaultArray,
    extraScopes = defaultArray,
    matchMode
  ) => {
    if ((!scopes.length && !extraScopes.length) || !tokenScopes.length) {
      return;
    }

    const getIsScopeMatched = scope =>
      tokenScopes.some(
        tokenScope => scope.toLowerCase() === tokenScope.toLowerCase()
      );
    const requiredScopes = [...new Set([...scopes, ...extraScopes])];
    if (matchMode === PermissionMatchMode.SOME) {
      return requiredScopes.some(getIsScopeMatched);
    }

    return requiredScopes.every(getIsScopeMatched);
  }
)(
  (state, remoteConfigKey, extraScopes = defaultArray, matchMode) =>
    `${remoteConfigKey}:${extraScopes.join(',')}:${matchMode}`
);

export default getIsPermissionMatched;
